var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendarPlus = function SvgCalendarPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.5a.833.833 0 011.667 0v.833h6.666V2.5A.833.833 0 1115 2.5v.833h1.667c.92 0 1.666.747 1.666 1.667v11.667c0 .92-.746 1.666-1.666 1.666H3.333c-.92 0-1.666-.746-1.666-1.666V5c0-.92.746-1.667 1.666-1.667H5V2.5zM3.333 16.667V5h13.334v11.667H3.333zm6.667-10a.833.833 0 00-.833.833V10h-2.5a.833.833 0 000 1.667h2.5v2.5a.833.833 0 001.666 0v-2.5h2.5a.833.833 0 000-1.667h-2.5V7.5A.833.833 0 0010 6.667z",
    fill: "#0163FF"
  })));
};

export default SvgCalendarPlus;